import { TApplicationState } from '../../types/redux';

export const selectFormRegion = (state: TApplicationState) => state.requestFormV2.form.region;
